import { useDialog } from '@dni-hooks/useDialog'
import { Button } from '@pets-ui/Button/Button'
import { Dialog } from '@pets-ui/Dialog/Dialog'
import { DialogActions } from '@pets-ui/DialogActions/DialogActions'
import { DialogContent } from '@pets-ui/DialogContent/DialogContent'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'

export const DIALOG_UNSUPPORTED_SELF_CANCEL = 'DIALOG_UNSUPPORTED_SELF_CANCEL'

export interface DialogUnsupportedSelfCancelExtraProps {
  isMerchant: boolean
}

export function DialogUnsupportedSelfCancel() {
  const { open, closeDialog, isMerchant } = useDialog<DialogUnsupportedSelfCancelExtraProps>(DIALOG_UNSUPPORTED_SELF_CANCEL)

  return (
    <Dialog onClose={closeDialog} open={open} maxWidth={320} fullWidth>
      <DialogHeader align="center" title="此訂單不支援自行取消" />
      <DialogContent>
        <Text color={colors.grey800}>
          {isMerchant
            ? '此類付款方式（如 ATM、PayMe）不支援自行取消，逾期未付將自動失效。'
            : '此類付款方式（如 ATM、超商代碼、PayMe）不支援自行取消，逾期未付將自動失效。'}
        </Text>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} variant="filled" color="primary" fullWidth>確認</Button>
      </DialogActions>
    </Dialog>
  )
}
